import { useQuery } from 'react-query';
import { API } from 'api';
import { startCase } from 'lodash';

export interface ISuspensionType {
  id: string;
  name: string;
  order: number;
  disableAccrual: boolean;
  disableWithdrawal: boolean;
}

export const mapSuspensionTypesToOptions = (types: ISuspensionType[]) => {
  return types.sort((a, b) => a.order - b.order).map((t) => ({ label: startCase(t.name), value: t.name }));
};

const getSuspensionTypesList = async (): Promise<ISuspensionType[]> => {
  const res = await API.newGet('/api/admin/suspension/types/list');
  return res.data.data;
};

export const useSuspensionTypesListData = () => {
  return useQuery(['suspensionTypesList'], () => getSuspensionTypesList());
};
